import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DriversService } from 'src/app/root/drivers.service';
import { SnackBarService } from 'src/app/shared/snackbar.service';
import {
  CreateDriverForApplicantRequestRetool
} from 'src/app/types';
import { NetworkActiveComponent } from '../../shared/networkActive.component';

interface FormGroupValue {
  name: string;
  phoneNumber: string;
  email: string;
  isAdmin: boolean;
  isDriver: boolean;
  password: string;
}

@Component({
  selector: 'lohi-invite-tour-driver',
  templateUrl: './invite-tour-driver.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Invite5fTourDriverComponent extends NetworkActiveComponent implements OnInit{
  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private driversService: DriversService,
    private snackBar: SnackBarService,
    private router: Router,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: [null, [Validators.required]],
      phoneNumber: [null, [Validators.required]],
      email: [null, [Validators.required]],
      isAdmin: [false, [Validators.required]],
      isDriver: [true, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  public async invite() {
    if (this.networkActive$$.value) {
      return;
    }

    if (this.formGroup.invalid) {
      return;
    }

    try {
      this.networkActive$$.next(true);
      const value: FormGroupValue = this.formGroup.value;
      const tourUserInvite: CreateDriverForApplicantRequestRetool = {
        driverName: value.name,
        phoneNumber: value.phoneNumber,
        email: value.email,
        password: value.password,
        is5FTourDriver: value.isDriver,
        isAdmin: value.isAdmin
      };

      const success = await this.driversService.invite5fTourUser(tourUserInvite);
      if (!success) {
        return;
      }

      this.snackBar.showMessage('5F Tours User Invited!');
      this.router.navigate(['/', 'drivers']);
    } finally {
      this.networkActive$$.next(false);
    }
  }
}
